var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('v-toolbar',{attrs:{"fixed":"","dark":"","id":"main-toolbar","app":""}},[_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.$emit('sidebar')}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13738095","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 273
// module chunks = 1